import { Component, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { trackingDomainsService } from '@/services/tracking-domains.service';
import { TrackingDomain } from '@/models/tracking-domain/tracking-domain';
import { IMailWizzEntity } from '@/models/common/mailwizz-entity';
import { INamedEntity } from '@/models/common/named-entity';
import { appSettingsModule } from '@/store/app-settings-module';

@Component
export default class TrackingDomainsComponent extends Vue {

    readonly selectListFormatter = (entity: IMailWizzEntity & INamedEntity) => { return { text: entity.name, value: entity } }
    
    trackingDomains: TrackingDomain[] = []
    selectedTrackingDomains: TrackingDomain[] = []
    loading = true
    saving = false

    get mailWizzInstanceId() { return appSettingsModule.activeMailWizzId }

    @Watch('mailWizzInstanceId')
    async mailWizzInstanceIdChanged(){
        await this.refresh()
    }

    async mounted() {
        await this.refresh()
    }

    async refresh() {
        try {
            this.loading = true
            this.trackingDomains = await trackingDomainsService.getAll<TrackingDomain>()
            this.selectedTrackingDomains = this.trackingDomains.filter(x => x.active)
        }
        finally {
            this.loading = false
        }
    }

    async save() {
        try {
            this.saving = true
            const inactiveTrackingDomains = this.trackingDomains
                .filter(x => this.selectedTrackingDomains.indexOf(x) < 0)
                .map(x => x.name)
            
            await trackingDomainsService.post({
                data: inactiveTrackingDomains,
                path: '/deactivate'
            })
        }
        finally {
            this.saving = false
        }
    }
}
